export default __webpack_public_path__ + "static/media/CNo.91-0.12239883.jpg";